import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHero, Empty } from "../components/ui-parts";

export default function SearchPage() {
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [r, setR] = useState(null);
  useEffect(() => { if (q) api.get("/search", { params: { q } }).then(x => setR(x.data)); }, [q]);
  return (
    <div data-testid="search-page">
      <PageHero badge="Search" title={`Results for "${q}"`} />
      <section className="section">
        <div className="container-narrow space-y-8">
          {!r ? <p>Loading…</p> : (
            <>
              {Object.entries({ Courses: r.courses, Programmes: r.programmes, Trainings: r.trainings, Volunteers: r.volunteers, Books: r.books, News: r.news }).map(([k, v]) => v && v.length > 0 && (
                <div key={k}>
                  <h3 className="font-heading text-2xl text-[var(--js-primary)] mb-3">{k}</h3>
                  <div className="grid gap-3 md:grid-cols-2">
                    {v.map(item => (
                      <div key={item.id} className="js-card p-4" data-testid={`search-item-${item.id}`}>
                        <div className="font-semibold">{item.name || item.title || item.full_name}</div>
                        {item.description && <p className="text-sm text-[var(--js-muted)] line-clamp-2 mt-1">{item.description}</p>}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              {r.districts?.length > 0 && (
                <div>
                  <h3 className="font-heading text-2xl text-[var(--js-primary)] mb-3">Districts</h3>
                  <div className="flex flex-wrap gap-2">
                    {r.districts.map(d => <Link key={d} to={`/districts/${encodeURIComponent(d)}`} className="js-chip">{d}</Link>)}
                  </div>
                </div>
              )}
              {r.courses.length + r.programmes.length + r.trainings.length + r.volunteers.length + r.books.length + r.news.length + r.districts.length === 0 && <Empty title="No results" />}
            </>
          )}
        </div>
      </section>
    </div>
  );
}
